import type { FaireProductEntity } from "../../entity_types/product";

export const p_3pyymwa96f: FaireProductEntity = {
  token: "p_3pyymwa96f",
  type: "product",
  name: "I ❤️ Matcha Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/607500f29cd62683758e396f8dcf26fe362b272bac6fec464bd13061b2c963ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efc169014be7ba4e42ec82b35ee9f9f4522ace6ab585d8f16c8a8f6dddf0dc45.jpeg",
    "https://cdn.faire.com/fastly/3f8207c8fb1b3a8c24a12d1ebbae1848ca3b4368d49bad4bbd511aa274157db5.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/6276ea18bdb46212b8307273a248f07ccb212d4f0c9b37b1de059b0e97f7013d.jpeg",
    "https://cdn.faire.com/fastly/0913f57a2af58eb5d4fb8d59a9154ef20deb55ebe7af76849a1d10f5962200c1.jpeg",
    "https://cdn.faire.com/fastly/32c922495f6edc61a10938f22bfab1ff7cfdde02fa4bda23a8a9711901249e9a.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks pair perfectly with quiet mornings and green froth. It only makes sense that something so earthy and energizing would go on your feet!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:16.961Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
